<template>
  <header class="app-header-container">
    <v-btn large icon @click="toggleDrawer">
      <v-icon color="black">mdi-menu</v-icon>
    </v-btn>
    <router-link to="/" class="app-header-logo">
      <img src="../assets/logo.png" alt="" style="height: 35px;" />
    </router-link>
  </header>
</template>

<script>
import * as drawerStore from "../stores/drawer";

export default {
  name: "AppHeader",
  methods: {
    toggleDrawer() {
      drawerStore.mutations.setIsOpen(!drawerStore.state.isOpen);
    }
  }
};
</script>

<style>
.app-header-container {
  -moz-align-items: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  align-items: center;
  background: #ffffff;
  cursor: default;
  height: 55px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: var(--header-z-index);
  display: grid;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.4);
  grid-template-columns: 40px 1fr 40px;
}

.app-header-logo {
  display: flex;
  justify-content: center;
}
</style>
